export const STAR_RATING_KEY = 'starRatings[]';
